var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"text-footer"},[_vm._v("\n    "+_vm._s(_vm.$t("layout.footer.poweredBy"))+"\n  ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('a',{attrs:{"href":"http://www.linkconsulting.com/","target":"_blank","rel":"noopener"}},[_c('img',{staticClass:"image",attrs:{"src":require("../../assets/img/link_blue.png")}})])])
}]

export { render, staticRenderFns }